import { LOG_NAMES } from './constants';
export const hasRequiredFields = (payload) => {
    return !!(payload.severity &&
        typeof payload.severity === 'string' &&
        payload.eventName &&
        typeof payload.eventName === 'string' &&
        payload.logData &&
        typeof payload.logData === 'object' &&
        payload.logName &&
        typeof payload.logName === 'string' &&
        LOG_NAMES.includes(payload.logName));
};
//# sourceMappingURL=hasRequiredFields.js.map